/* GL Oct 28 2026. Collection page behaviour for the native filter layout (used by sections/gl-mood-row.liquid).
   Filtering works like a shop catalogue on desktop AND phones: ticks register instantly, the filter panel is never
   redrawn, and only the artworks, chips, counts and pagination refresh in the background (Shopify Section Rendering).
   Each new change cancels the previous request. The price slider refreshes when a handle is released (hooked into the
   slider directly, since it sends no events); typed price boxes refresh when you leave the box.
   Phones: a pinned "Show N works" button closes the Filter & sort panel.
   Also: removes the theme's "inert" lock on the desktop sidebar, shows chips above the artworks, cleans currency
   markup out of chip labels, sets grid columns by screen width, strips the repeated format from single-format titles,
   hides one-choice filter groups.
   Oct 29 2026: button wording, grid columns and the three clean-ups are now set in Customize (GL moods & filters)
   and read from data-gl-* attributes on .gl-moods; the old hard-coded values remain as fallbacks. */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function cfg(k, d) { var m = document.querySelector('.gl-moods'); var v = m && m.getAttribute('data-gl-' + k); return v ? v : d; }
  function on(k) { return cfg(k, 'true') !== 'false'; }
  function gridCss() {
    var a = parseInt(cfg('cols-mid', '3'), 10) || 3, b = parseInt(cfg('cols-wide', '5'), 10) || 5;
    return '@media (min-width:990px) and (max-width:1279px){.layout-grid{grid-template-columns:repeat(' + a + ',minmax(0,1fr)) !important}}' +
           '@media (min-width:1680px){.layout-grid{grid-template-columns:repeat(' + b + ',minmax(0,1fr)) !important}}';
  }
  var SUFFIX = /\s+[\u2014\u2013-]\s+(Gicl\u00e9e on Paper|Gallery Canvas|Canvas Print|Framed Print|Framed Piece|Gicl\u00e9e sur papier|Toile de galerie|\u0152uvre encadr\u00e9e)\s*$/;
  var timer = null, ctrl = null, showBar = null;

  var st = document.createElement('style');
  st.textContent = '.collection-feed__main > .collection-feed__active-filters{border:0 !important;padding:0 0 16px !important;margin:0 !important}' +
    '.checkbox-filter__item.gl-zero{opacity:.45}' +
    '#gl-show{display:none;position:fixed;left:0;right:0;bottom:0;z-index:2147483000;background:#fff;border-top:1px solid #ece8de;padding:12px 16px calc(12px + env(safe-area-inset-bottom))}' +
    '#gl-show.is-on{display:block}' +
    '#gl-show button{display:block;width:100%;min-height:52px;background:#1A1A1A;color:#fff;border:0;border-radius:2px;font-size:16px;letter-spacing:.06em;text-transform:uppercase}' +
    '@media (max-width:989px){.collection-feed__sidebar button[type="submit"]{display:none !important}.collection-feed__sidebar .collection-feed__filter-sort-form{padding-bottom:96px}}';
  document.head.appendChild(st);

  function fr() { var m = document.querySelector('[data-gl-locale]'); return m && m.getAttribute('data-gl-locale') === 'fr'; }
  function form() { return document.querySelector('.collection-feed__filter-sort-form'); }
  function singleFormat() {
    var el = document.querySelector('[data-gl-single-format]');
    return el && el.getAttribute('data-gl-single-format') === 'true';
  }
  function sid(el) {
    var s = el && el.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  function esc(v) { return window.CSS && CSS.escape ? CSS.escape(v) : v.replace(/"/g, '\\"'); }
  function isPrice(el) { return el && el.name && el.name.indexOf('filter.v.price') === 0; }
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () { var f = form(); if (f) load(paramsFromForm(f), false); }, delay);
  }

  function showLabel(n) {
    if (n === null || n === undefined || n === '') return cfg('show-none', fr() ? 'Voir les \u0153uvres' : 'Show works');
    n = Number(n);
    var tpl = n === 1 ? cfg('show-one', fr() ? 'Voir [n] \u0153uvre' : 'Show [n] work') : cfg('show-many', fr() ? 'Voir [n] \u0153uvres' : 'Show [n] works');
    return tpl.replace('[n]', n);
  }
  function totalNow() { var t = document.querySelector('[data-gl-total]'); return t ? t.getAttribute('data-gl-total') : null; }
  function ensureShowBar() {
    if (showBar) return showBar;
    showBar = document.createElement('div');
    showBar.id = 'gl-show';
    showBar.innerHTML = '<button type="button"></button>';
    showBar.querySelector('button').textContent = showLabel(totalNow());
    showBar.querySelector('button').addEventListener('click', function () {
      var d = document.querySelector('.collection-feed__sidebar overlay-drawer');
      var c = d && (d.querySelector('.overlay-drawer__close-button button') || d.querySelector('.overlay-drawer__close-button'));
      if (c) c.click(); else if (d) d.setAttribute('open', 'false');
      showBar.classList.remove('is-on');
      var feed = document.querySelector('collection-feed');
      if (feed) setTimeout(function () { feed.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    });
    document.body.appendChild(showBar);
    return showBar;
  }

  function fixInert(d) {
    if (mq.matches) { if (d.hasAttribute('inert')) d.removeAttribute('inert'); }
    else if (d.getAttribute('open') !== 'true' && !d.hasAttribute('inert')) d.setAttribute('inert', '');
    var open = !mq.matches && d.getAttribute('open') === 'true';
    ensureShowBar().classList.toggle('is-on', open);
  }
  function watchDrawer() {
    document.querySelectorAll('.collection-feed__sidebar overlay-drawer').forEach(function (d) {
      fixInert(d);
      if (d.dataset.glInert) return;
      d.dataset.glInert = '1';
      new MutationObserver(function () { fixInert(d); }).observe(d, { attributes: true, attributeFilter: ['inert', 'open'] });
    });
  }
  function hookSliders() {
    document.querySelectorAll('.collection-feed__filter-sort-form .price-range__slider').forEach(function (s) {
      if (!s.noUiSlider || s.dataset.glHook) return;
      s.dataset.glHook = '1';
      s.noUiSlider.on('change.gl', function () { schedule(250); });
    });
  }
  function moveChips() {
    if (!mq.matches || !on('chips-top')) return;
    var chips = document.querySelector('.collection-feed__sidebar .collection-feed__active-filters');
    var main = document.querySelector('.collection-feed__main');
    if (!chips || !main) return;
    var old = main.querySelector(':scope > .collection-feed__active-filters');
    if (old && old !== chips) old.remove();
    main.insertBefore(chips, main.firstChild);
  }
  function cleanChips() {
    document.querySelectorAll('.collection-feed__active-filters').forEach(function (c) {
      var w = document.createTreeWalker(c, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf('<') !== -1) n.nodeValue = n.nodeValue.replace(/<[^>]*>/g, '').replace(/\s+-\s+/, ' \u2013 ');
      }
    });
  }

  function paramsFromForm(f) {
    var p = new URLSearchParams();
    new FormData(f).forEach(function (v, k) {
      if (v === '') return;
      if (k === 'filter.v.price.gte' && Number(v) <= 0) return;
      if (k === 'filter.v.price.lte') {
        var el = f.querySelector('[name="filter.v.price.lte"]');
        var max = el && el.getAttribute('max');
        if (max && Number(v) >= Number(max)) return;
      }
      p.append(k, v);
    });
    return p;
  }
  function syncForm(f, p) {
    f.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
      var on = p.getAll(i.name).indexOf(i.value) !== -1;
      if (i.checked !== on) i.checked = on;
    });
    f.querySelectorAll('input[type="radio"][name="sort_by"]').forEach(function (i) {
      if (p.get('sort_by')) i.checked = (p.get('sort_by') === i.value);
    });
  }

  /* Fetch the collection section (and the mood row, for the total) and swap in artworks, chips, counts and pagination. */
  function load(p, scrollUp) {
    var feed = document.querySelector('collection-feed');
    var mainId = sid(feed);
    var moodsId = sid(document.querySelector('.gl-moods'));
    var qs = p.toString();
    if (!mainId) { location.search = qs; return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    if (feed) feed.classList.add('gl-loading');
    if (showBar) showBar.querySelector('button').textContent = cfg('updating', fr() ? 'Mise \u00e0 jour\u2026' : 'Updating\u2026');
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
    var ids = moodsId ? mainId + ',' + moodsId : mainId;
    fetch(location.pathname + '?' + (qs ? qs + '&' : '') + 'sections=' + encodeURIComponent(ids), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json[mainId] || '', 'text/html');
        var total = null;
        if (moodsId && json[moodsId]) {
          var md = new DOMParser().parseFromString(json[moodsId], 'text/html');
          var t = md.querySelector('[data-gl-total]');
          if (t) {
            total = t.getAttribute('data-gl-total');
            var cur = document.querySelector('[data-gl-total]');
            if (cur) cur.setAttribute('data-gl-total', total);
          }
        }
        var main = document.querySelector('.collection-feed__main');
        var newMain = doc.querySelector('.collection-feed__main');
        if (main && newMain) {
          main.innerHTML = newMain.innerHTML;
          var chips = doc.querySelector('.collection-feed__active-filters');
          if (chips && chips.querySelector('a')) main.insertBefore(document.importNode(chips, true), main.firstChild);
        }
        var op = document.querySelector('.container--pagination');
        var np = doc.querySelector('.container--pagination');
        if (op) op.innerHTML = np ? np.innerHTML : '';
        var f = form();
        if (f) f.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
          var li = i.closest('.checkbox-filter__item');
          var c = li && li.querySelector('.checkbox-filter__count');
          if (!c) return;
          var n = doc.querySelector('input[type="checkbox"][name="' + esc(i.name) + '"][value="' + esc(i.value) + '"]');
          var nli = n && n.closest('.checkbox-filter__item');
          var nc = nli && nli.querySelector('.checkbox-filter__count');
          c.textContent = nc ? nc.textContent : '(0)';
          li.classList.toggle('gl-zero', !i.checked && (!nc || /\(0\)/.test(nc.textContent)));
        });
        cleanChips();
        if (showBar) showBar.querySelector('button').textContent = showLabel(total);
        if (feed) feed.classList.remove('gl-loading');
        if (scrollUp && feed) feed.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') location.reload(); });
  }

  /* Take over filter changes (desktop and phones) before the theme redraws everything.
     Typed price boxes are not stopped, so the slider can follow them; the refresh comes a moment later. */
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('.collection-feed__filter-sort-form');
    if (!f) return;
    var price = isPrice(e.target);
    if (!price) e.stopImmediatePropagation();
    schedule(price ? 450 : 120);
  }, true);

  /* Chips, Clear all and page numbers also refresh in place (removing a price filter reloads so the slider resets). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.collection-feed__active-filters a, .collection-feed__sidebar a[href], .container--pagination a[href]');
    if (!a || !a.href) return;
    var u = new URL(a.href, location.href);
    if (u.pathname !== location.pathname) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    u.searchParams.delete('section_id');
    var priceWasOn = location.search.indexOf('filter.v.price') !== -1;
    var priceNowOn = u.searchParams.has('filter.v.price.gte') || u.searchParams.has('filter.v.price.lte');
    if (priceWasOn && !priceNowOn) { location.assign(u.pathname + '?' + u.searchParams.toString()); return; }
    var f = form();
    if (f) syncForm(f, u.searchParams);
    load(u.searchParams, !!a.closest('.container--pagination'));
  }, true);

  function tune() {
    watchDrawer();
    hookSliders();
    moveChips();
    cleanChips();
    document.querySelectorAll('.collection-feed__main layout-grid').forEach(function (g) {
      if (!g.shadowRoot || g.dataset.glCols || !g.querySelector('.product__grid-item')) return;
      var s = document.createElement('style');
      s.textContent = gridCss();
      g.shadowRoot.appendChild(s);
      g.dataset.glCols = '1';
    });
    if (singleFormat() && on('strip-format')) {
      document.querySelectorAll('.collection-feed__main .product-thumbnail__title').forEach(function (a) {
        if (a.dataset.glT) return;
        a.dataset.glT = '1';
        a.childNodes.forEach(function (n) {
          if (n.nodeType === 3 && SUFFIX.test(n.textContent)) n.textContent = n.textContent.replace(SUFFIX, '');
        });
      });
    }
    document.querySelectorAll('.collection-feed__filters accordion-toggle').forEach(function (acc) {
      if (acc.dataset.glChecked || !on('hide-single')) return;
      acc.dataset.glChecked = '1';
      var boxes = acc.querySelectorAll('input[type="checkbox"]');
      if (boxes.length > 0 && boxes.length <= 1 && !acc.querySelector('input:checked')) acc.style.display = 'none';
    });
    var f = form();
    if (f && mq.matches && !f.dataset.glDone) {
      f.dataset.glDone = '1';
      f.querySelectorAll('details').forEach(function (d) {
        if (d.querySelector('input[type="radio"]')) d.open = false;
      });
    }
  }

  if (mq.addEventListener) mq.addEventListener('change', watchDrawer);
  document.addEventListener('DOMContentLoaded', tune);
  window.addEventListener('load', hookSliders);
  new MutationObserver(tune).observe(document.documentElement, { childList: true, subtree: true });
})();
